(function () {
  const initializeFaq = (faq) => {
    if (faq.dataset.rushInitialized === "true") return;
    faq.dataset.rushInitialized = "true";

    const search = faq.querySelector("[data-faq-search]");
    const filters = Array.from(faq.querySelectorAll("[data-faq-filter]"));
    const groups = Array.from(faq.querySelectorAll("[data-faq-group]"));
    const items = Array.from(faq.querySelectorAll("[data-faq-item]"));
    const status = faq.querySelector("[data-faq-status]");
    const empty = faq.querySelector("[data-faq-empty]");
    let activeCategory = "all";
    let searchAnalyticsTimer;

    const publishFaqEvent = (eventName, eventData) => window.RushAnalytics?.publish?.(eventName, eventData);

    const normalize = (value) => value.toLocaleLowerCase().replace(/\s+/g, " ").trim();

    const updateFilterButtons = () => {
      filters.forEach((button) => {
        button.setAttribute("aria-pressed", String(button.dataset.faqFilter === activeCategory));
      });
    };

    const applyFilters = () => {
      const query = normalize(search?.value || "");
      let visibleCount = 0;

      items.forEach((item) => {
        const matchesCategory = activeCategory === "all" || item.dataset.category === activeCategory;
        const matchesSearch = !query || normalize(item.textContent).includes(query);
        const isVisible = matchesCategory && matchesSearch;
        item.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      groups.forEach((group) => {
        group.hidden = !Array.from(group.querySelectorAll("[data-faq-item]")).some((item) => !item.hidden);
      });

      if (empty) empty.hidden = visibleCount !== 0;
      if (status) status.textContent = `${visibleCount} ${visibleCount === 1 ? "answer" : "answers"} found.`;
      return visibleCount;
    };

    filters.forEach((button) => {
      button.addEventListener("click", () => {
        activeCategory = button.dataset.faqFilter || "all";
        updateFilterButtons();
        const resultCount = applyFilters();
        publishFaqEvent("faq_category_selected", { category: activeCategory, result_count: resultCount });
      });
    });

    search?.addEventListener("input", () => {
      if (search.value.trim()) {
        activeCategory = "all";
        updateFilterButtons();
      }
      const resultCount = applyFilters();
      window.clearTimeout(searchAnalyticsTimer);
      if (search.value.trim()) {
        searchAnalyticsTimer = window.setTimeout(() => {
          publishFaqEvent("faq_search_completed", {
            query_length: Math.min(search.value.trim().length, 200),
            result_count: resultCount,
            has_results: resultCount > 0,
          });
        }, 600);
      }
    });

    search?.addEventListener("keydown", (event) => {
      if (event.key !== "Escape" || !search.value) return;
      search.value = "";
      applyFilters();
    });

    items.forEach((item) => {
      item.addEventListener("toggle", () => {
        if (!item.open) return;
        publishFaqEvent("faq_answer_opened", {
          category: item.dataset.category || "",
          answer_id: item.id.replace(/^Faq-/, ""),
        });
      });
    });

    const openHashTarget = () => {
      if (!window.location.hash.startsWith("#Faq-")) return;
      const targetId = decodeURIComponent(window.location.hash.slice(1));
      const target = document.getElementById(targetId);
      if (!target || !faq.contains(target)) return;
      activeCategory = "all";
      if (search) search.value = "";
      updateFilterButtons();
      applyFilters();
      target.open = true;
      target.querySelector("summary")?.focus({ preventScroll: true });
      target.scrollIntoView({ block: "center", behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" });
    };

    window.addEventListener("hashchange", openHashTarget);
    updateFilterButtons();
    applyFilters();
    openHashTarget();
  };

  const initializeAllFaqs = (root = document) => {
    root.querySelectorAll("[data-faq]").forEach(initializeFaq);
  };

  initializeAllFaqs();
  document.addEventListener("shopify:section:load", (event) => initializeAllFaqs(event.target));
})();
